import { Injectable } from '@angular/core';

import { FsMapLprCamerasServiceProvider, IFsMap } from '@lib/geo/core';
import {
  FsLprCamera,
  FsLprCameraAdvancedMarker,
  FsLprQueryCameraAdvancedMarker,
} from '@lib/vehicle-intelligence';

@Injectable()
export class MapLprCamerasFacadeService<TMap extends IFsMap> extends FsMapLprCamerasServiceProvider<TMap> {
  constructor(private readonly provider: FsMapLprCamerasServiceProvider<TMap>) {
    super();
  }

  public get id(): string {
    return this.provider.id;
  }

  public get geospatialProvider(): string {
    return this.provider.geospatialProvider;
  }

  public get flockAvailable(): boolean {
    return this.provider.flockAvailable;
  }

  public get flockV3Available(): boolean {
    return this.provider.flockV3Available;
  }

  public get deckGlIconLayer(): any {
    return this.provider.deckGlIconLayer;
  }

  public get statusLayer(): any {
    return this.provider.statusLayer;
  }

  public get makesParam(): string[] {
    return this.provider.makesParam;
  }

  public get lprCameras(): any[] {
    return this.provider.lprCameras;
  }

  public get flockMarkers(): FsLprCameraAdvancedMarker[] {
    return this.provider.flockMarkers;
  }

  public get flockV3Markers(): FsLprCameraAdvancedMarker[] {
    return this.provider.flockV3Markers;
  }

  public get lprMarkers(): FsLprQueryCameraAdvancedMarker[] {
    return this.provider.lprMarkers;
  }

  public get layerData(): FsLprCamera[] {
    return this.provider.layerData;
  }

  public get isSelected(): boolean {
    return this.provider.isSelected;
  }

  public set isSelected(value: boolean) {
    this.provider.setSelected(value);
  }

  public get lprPermissions(): boolean {
    return this.provider.lprPermissions;
  }

  public get isAvailable(): boolean {
    return this.provider.isAvailable;
  }

  public getMarkers(): (FsLprCameraAdvancedMarker | FsLprQueryCameraAdvancedMarker)[] {
    return this.provider.getMarkers();
  }

  public onMapLoaded(map: TMap): void {
    return this.provider.onMapLoaded(map);
  }

  public addToMap(): void {
    return this.provider.addToMap();
  }

  public removeFromMap(): void {
    return this.provider.removeFromMap();
  }

  public openCameraDetails(camera: FsLprCamera): void {
    return this.provider.openCameraDetails(camera);
  }

  public setMakesParam(makes: string[]): void {
    return this.provider.setMakesParam(makes);
  }

  public setSelected(selected: boolean): void {
    return this.provider.setSelected(selected);
  }

  public refreshData(): void {
    return this.provider.refreshData();
  }

  public destroy(): void {
    return this.provider.destroy();
  }

  public select(id: string): void {
    return (this.provider as any).select?.(id);
  }

  public getMakesParams(params: string[], isLayerOn: boolean): void {
    return this.provider.getMakesParams(params, isLayerOn);
  }
}
